import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 40px;
  display: flex;

  .imageWrapper {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  .contentWrapper {
    width: 100%;
    margin-left: 12px;
    font-family: "Open Sans", sans-serif;

    h2 {
      font-weight: 700;
      font-size: 22px;
      line-height: 33px;
      color: #324150;
    }

    h3 {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      margin-top: 6px;
      color: #8697a8;
      letter-spacing: 0.1em;
      text-transform: uppercase;
    }

    p {
      color: #BEC2C6;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      font-weight: 600;
      margin-top: 30px;
      margin-bottom: 0;
    }

    .icons-wrapper {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
      
      .icons-text-margin {
        margin-right: 23px;
      }

      .icons-text-wrapper {
        div {
          display: flex;
          align-items: center;
          
          &+div {
            margin-top: 16px;
          }

          i {
            margin-right: 12px;
          }

          span {
            color: #8697A8;
            font-size: 12px;
            font-weight: 600;
            line-height: 16px;
          }
        }
      }
    }
  }

  .contentWrapperPro {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
